// @dynamic-i18n-keys
// Dynamic t() at line 21 (interest.id 1..10):
//   widgets.aboutMe.interests.1
//   widgets.aboutMe.interests.2
//   widgets.aboutMe.interests.3
//   widgets.aboutMe.interests.4
//   widgets.aboutMe.interests.5
//   widgets.aboutMe.interests.6
//   widgets.aboutMe.interests.7
//   widgets.aboutMe.interests.8
//   widgets.aboutMe.interests.9
//   widgets.aboutMe.interests.10
import type { FC } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './Interests.scss';

export interface Props {
  interests: {
    id: number;
    value: string;
  }[];
  className?: string;
}

const Interests: FC<Props> = ({ interests, className }) => {
  const { t } = useTranslation();
  return (
    <div className={classnames(s['root'], className)}>
      {interests.map(interest => (
        <div key={interest.id} className={s['interest-group']}>
          <div className={s['interest-label']}>
            {t(`widgets.aboutMe.interests.${interest.id}`)}
          </div>
          <div className={s['interest-value']}>{interest.value}</div>
        </div>
      ))}
    </div>
  );
};
Interests.displayName = 'Interests';

export default Interests;
